import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Utility } from '../core/common';
import { AuthState } from '../states/auth.state';
import { SharedService } from './shared.service';

declare let dataLayer: any[];
declare let clarity: any;


@Injectable({
  providedIn: 'root'
})
export class AnalyticsService implements OnDestroy {
  user: any;

  constructor(private sharedService: SharedService, store: Store) {
    this.user = Utility.clone(store.selectSnapshot(state => state.auth.user));
    if (sharedService.isBrowser)
      AuthState.user$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(user => this.onUserLoad(user));
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  private onUserLoad(data: any): void {
    if (data?.Seeker && !this.user?.Seeker)
      this.gtmEvent('signup', 'seeker');
    this.user = data;
  }

  gtmEvent(action: string, category?: string, label?: string, nonInteraction?: boolean, value?: number) {
    if (this.sharedService.isBrowser && typeof dataLayer !== 'undefined') {
      const data = {
        'event': 'ga-event',
        'event_action': action,
        'event_category': category,
        'event_label': label,
        'event_value': value,
        'non_interaction': !!nonInteraction
      };

      if (!environment.production) console.log('google-analytics', data);
      else {
        dataLayer.push(data);
        this.clarityTag(`${data.event_category}_${data.event_action}_${data.event_label}`, data.event_value?.toString())
      }
    }
  }

  clarityTag(tag: string, value: string) {
    if (!environment.production) {
      console.log('clarity tag', tag, value);
      return;
    }
    if (typeof (clarity) == 'undefined') return;
    clarity("set", tag, value);
  }

}
